import { get, range, keys } from 'lodash';
import { camelCase, startCase } from 'lodash/string';

const NA_SELECT_VALUE = '0';

class EditAddonCtrl {
  constructor($filter, $mdDialog, $mdToast, $q, AddOn, ClientSettings, Ledger, User) {
    this.$filter = $filter;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$q = $q;
    this.AddOn = AddOn;
    this.addonTypes = keys(this.AddOn.typeLabels);
    this.ClientSettings = ClientSettings;
    this.volumeKeys = Ledger.volumeKeys;
    this.volumeLabels = Ledger.volumeLabels;
    this.clientId = User.getClientId();
    this.onDateActiveChange = this.onDateActiveChange.bind(this);
    this.onDateInactiveChange = this.onDateInactiveChange.bind(this);
  }

  $onInit() {
    this.addon = new this.AddOn({
      id: this.addonId,
      clientId: this.clientId,
    });
    this.addonVM = this.addon.$viewModel();

    this.selectedIntegration = null;

    if (!this.addonId) {
      this.setDefaults();
    }

    this.initCloseDayOfMonthIfNull();
    this.clientSettings = new this.ClientSettings(this.clientId);
  }

  setDefaults() {
    if (!this.addonVM.dateActive) {
      this.addonVM.dateActive = this.getCurrentDate();
    }
  }

  capitalizeText(text) {
    return startCase(camelCase(text));
  }

  getCurrentDate() {
    return this.$filter('date')(new Date(), 'yyyy-MM');
  }

  cancel() {
    this.$mdDialog.cancel();
  }

  onDateActiveChange(dateActive) {
    this.addonVM.dateActive = dateActive;
  }

  onDateInactiveChange(dateInactive) {
    this.addonVM.dateInactive = dateInactive;
  }

  isDatesInvalid() {
    if (!this.addonVM.dateActive || !this.addonVM.dateInactive) {
      return false;
    }

    const active = new Date(this.addonVM.dateActive);
    const inactive = new Date(this.addonVM.dateInactive);

    return active >= inactive;
  }

  updateViewModelWithSelectedIntegration() {
    this.addonVM.stripeId = (this.selectedIntegration && this.selectedIntegration.stripeId) || null;
    this.addonVM.squareMerchantId =
      (this.selectedIntegration && this.selectedIntegration.merchantId) || null;
  }

  save() {
    this.updateViewModelWithSelectedIntegration();
    this.setCloseDayOfMonth();
    this.addon
      .$createOrUpdate(this.addonVM.$data())
      .then(() => this.$mdDialog.hide())
      .catch(e => {
        const message =
          get(e, 'data.messages[0].message') || 'There was an problem saving your changes';

        this.$mdToast.show(this.$mdToast.simple().textContent(message).hideDelay(3000));
      });
  }

  initCloseDayOfMonthIfNull() {
    if (!this.addonVM.closeDayOfMonth) {
      this.addonVM.closeDayOfMonth = NA_SELECT_VALUE;
    }
  }

  setCloseDayOfMonth() {
    if (this.addonVM.closeDayOfMonth === NA_SELECT_VALUE) {
      this.addonVM.closeDayOfMonth = null;
    } else {
      this.addonVM.closeDayOfMonth = parseInt(this.addonVM.closeDayOfMonth, 10);
    }
  }

  isFormInvalid() {
    if (!this.addonVM.name) {
      return true;
    }

    if (this.isDatesInvalid()) {
      return true;
    }

    return false;
  }
}

Object.assign(EditAddonCtrl.prototype, {
  collectionSelection: [
    'Stripe',
    'Square',
    'Not Required',
    'Cannot Optimize',
    '3rd Party Login',
    'Other Integration',
    'Requested',
  ],
  optimizationSelection: [
    'Optimized',
    'Cannot Optimize',
    'Not Optimized',
    'Not Available',
    'Opt Out',
  ],
  thirdPartyLoginSelection: [
    { label: 'Available', value: true },
    { label: 'Unavailable', value: false },
  ],
});
EditAddonCtrl.prototype.closeDaysOfMonth = range(0, 32);

export default EditAddonCtrl;
